import { jsx } from "react/jsx-runtime";
import { Grid } from "@zillow/constellation";
import PropTypes from "prop-types";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockGridLayout = ({
  attrs,
  index,
  innerBlocks
}) => {
  var _a, _b, _c, _d, _e;
  const attributes = {
    gridTemplateColumns: {
      default: "repeat(12, minmax(0, 1fr))"
    },
    gap: {
      default: "md",
      lg_lte: "md",
      sm_lte: "md"
    },
    justifyContent: {
      default: "center"
    },
    alignItems: {
      default: "center"
    },
    // When child of things that center the content, we still want
    // Grid to be stretched. For example, as child of Carousel.
    alignSelf: {
      default: "stretch"
    },
    ...attrs
  };
  if (((_a = attributes == null ? void 0 : attributes.gap) == null ? void 0 : _a.lg_lte) === "xl" || !((_b = attributes == null ? void 0 : attributes.gap) == null ? void 0 : _b.lg_lte)) {
    attributes.gap.lg_lte = "md";
  }
  if (((_c = attributes == null ? void 0 : attributes.gap) == null ? void 0 : _c.sm_lte) === "lg" || ((_d = attributes == null ? void 0 : attributes.gap) == null ? void 0 : _d.sm_lte) === "xl" || !((_e = attributes == null ? void 0 : attributes.gap) == null ? void 0 : _e.sm_lte)) {
    attributes.gap.sm_lte = "md";
  }
  return /* @__PURE__ */ jsx(Grid, { display: "grid", ...attributes, children: generateBlockList({
    blocks: innerBlocks
  }) }, index);
};
BlockGridLayout.propTypes = {
  attrs: PropTypes.shape({}),
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};
export {
  BlockGridLayout as default
};
